import React from "react";
import { StyleSheet } from "react-native";

import { palette } from "../styles";
import Block from "./Block";
import Button from "./Button";
import Typography from "./Typography";

type Props = {
  description: string;
  onPress?: () => void;
  buttonLabel?: string;
  accentDescription?: string;
};

const InfoBlock = ({ buttonLabel, accentDescription, description, onPress }: Props) => {
  return (
    <Block borderRadius={2} marginVertical={2} padding={2.5} style={styles.infoContainer}>
      {!!accentDescription && (
        <Block paddingBottom={1}>
          <Typography center style={styles.info} type="primaryLink">
            {accentDescription}
          </Typography>
        </Block>
      )}
      <Typography center style={styles.info} type="white">
        {description}
      </Typography>

      {onPress && !!buttonLabel && (
        <Block marginHorizontal={2} marginTop={1.5}>
          <Button label={buttonLabel} onPress={onPress} type="tertiary" />
        </Block>
      )}
    </Block>
  );
};

export default React.memo(InfoBlock);

const styles = StyleSheet.create({
  info: {
    fontSize: 14,
    lineHeight: 22,
  },
  infoContainer: {
    backgroundColor: palette.primary.accent,
  },
});
